<div class="team-lead-substitution-form">
  <div *ngIf="ownCoverage" class="own-coverage v2-mb-4" data-id="own-agent-coverage">
    <typography-v2 look="text-semibold" class="d-block v2-mb-2">Your coverage</typography-v2>
    <div class="coverage-field v2-mb-3">
      <typography-v2 look="small" class="text-black-50">Who is covering for you?</typography-v2>
      <typography-v2>{{ ownCoverage.coveringName }}</typography-v2>
    </div>
    <div class="coverage-field v2-mb-3">
      <typography-v2 look="small" class="text-black-50">Start date</typography-v2>
      <typography-v2>{{ ownCoverage.startLabel }}</typography-v2>
    </div>
    <div class="coverage-field v2-mb-4">
      <typography-v2 look="small" class="text-black-50">End date</typography-v2>
      <typography-v2>{{ ownCoverage.endLabel }}</typography-v2>
    </div>
    <div class="d-flex justify-content-end">
      <button-v2
        type="destructive"
        buttonType="button"
        [disabled]="submitting"
        data-id="end-own-agent-coverage"
        (click)="endOwnCoverage()"
      >
        End coverage
      </button-v2>
    </div>
  </div>

  <tabs-v2
    class="v2-mb-4"
    [tabs]="tabs"
    [activeTab]="activeTab"
    (selectTab)="selectTab($event)"
  ></tabs-v2>

  <ng-container *ngIf="activeTab.value === CoverageTab.Setup">
    <typography-v2 *ngIf="loading" class="text-black-50">Loading...</typography-v2>

    <ng-container *ngIf="!loading">
      <typography-v2 class="text-black-50 v2-mb-4">
        Set up coverage for an agent on your team.
      </typography-v2>

      <form
        [formGroup]="formGroup"
        (ngSubmit)="startCoverage()"
        (keydown.enter)="$event.preventDefault()"
      >
        <formly-form [form]="formGroup" [model]="formModel" [fields]="fields"></formly-form>

        <div class="d-flex justify-content-end v2-mt-5">
          <button-v2 buttonType="submit" [disabled]="!formGroup.valid || submitting">
            Start coverage
          </button-v2>
        </div>
      </form>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="activeTab.value === CoverageTab.Active">
    <typography-v2 *ngIf="loadingActive" class="text-black-50">Loading...</typography-v2>

    <ng-container *ngIf="!loadingActive">
      <typography-v2 *ngIf="!activeCoverages.length" class="text-black-50">
        No active coverages.
      </typography-v2>

      <div
        *ngFor="let row of activeCoverages"
        class="coverage-row"
        [class.coverage-row--expanded]="expandedId === row.id"
      >
        <button type="button" class="coverage-row__header" (click)="toggleRow(row.id)">
          <div class="d-flex align-items-center">
            <user-picture-v2
              *ngIf="row.absentAgent"
              class="v2-mr-2"
              [picture]="row.absentAgent.picture"
              [label]="row.absentAgent.fullName"
              size="small"
            />
            <typography-v2 look="text-semibold">
              {{ row.absentAgent?.fullName || '—' }}
            </typography-v2>
          </div>
          <rdr-svg-icon
            [key]="expandedId === row.id ? 'chevron-top' : 'chevron-bottom'"
          ></rdr-svg-icon>
        </button>

        <div *ngIf="expandedId === row.id" class="coverage-row__body v2-mt-3">
          <div class="coverage-field v2-mb-3">
            <typography-v2 look="small" class="text-black-50">Who needs coverage?</typography-v2>
            <div class="d-flex align-items-center">
              <user-picture-v2
                *ngIf="row.absentAgent"
                class="v2-mr-2"
                [picture]="row.absentAgent.picture"
                [label]="row.absentAgent.fullName"
                size="small"
              />
              <typography-v2>{{ row.absentAgent?.fullName || '—' }}</typography-v2>
            </div>
          </div>
          <div class="coverage-field v2-mb-3">
            <typography-v2 look="small" class="text-black-50">
              Who will cover the absence?
            </typography-v2>
            <div class="d-flex align-items-center">
              <user-picture-v2
                *ngIf="row.coveringAgent"
                class="v2-mr-2"
                [picture]="row.coveringAgent.picture"
                [label]="row.coveringAgent.fullName"
                size="small"
              />
              <typography-v2>{{ row.coveringAgent?.fullName || '—' }}</typography-v2>
            </div>
          </div>
          <div class="coverage-field v2-mb-3">
            <typography-v2 look="small" class="text-black-50">Start date</typography-v2>
            <typography-v2>{{ row.startDate || '—' }}</typography-v2>
          </div>
          <div class="coverage-field v2-mb-4">
            <typography-v2 look="small" class="text-black-50">End date</typography-v2>
            <typography-v2>{{ row.throughDate || '' }}</typography-v2>
          </div>

          <div class="d-flex justify-content-end">
            <button-v2
              type="destructive"
              buttonType="button"
              [disabled]="submitting"
              (click)="endCoverage(row)"
            >
              End coverage
            </button-v2>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
